













import * as Moment from "moment";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DocumentSummary } from "../../../../../../domain/document";
import { Patient } from "../../../../../../domain/patient";
import { DialogSelector, instanceOfIOptionFilterable } from "../../../../../system";
import { ModelEditableMixin } from "../../../../../system/mixins";
import { IDocumentSelectCondition } from "../../../../dialogs";

@Component({
  components: {
    DialogSelector,
  }
})
export default class DocumentDialogSelector extends Mixins(ModelEditableMixin) {
  $refs!: {
    dialogSelector: DialogSelector,
  };

  @Prop()
  patient: Patient;

  @Prop({ default: null })
  ignoreDocumentId: number;

  @Prop()
  editingDocumentName: string;

  get condition(): IDocumentSelectCondition {
    return {
      name: "表示文書選択",
      patient: this.patient,
      ignoreDocumentId: this.ignoreDocumentId,
      editingDocumentName: this.editingDocumentName,
      isOtherPatientSelectable: this.isOtherPatientDocumentQuotable,
    };
  }

  get isOtherPatientDocumentQuotable(): boolean {
    return this.$configuration.behavior.document.editor.quotation.isOtherPatientDocumentQuotable;
  }

  format(source: DocumentSummary): string {
    return source
      ? Moment(source.updateDateTime).format("YYYY/MM/DD") + "更新" + " " + source.documentName
      : "";
  }

  select(): void {
    if (this.$refs.dialogSelector) {
      this.$refs.dialogSelector.select();
    }
  }

  /**
   * 編集画面側で患者読み込みが完了する前にダイアログを開くと、
   * 異なる患者の文書を選択できてしまうので対策している
   */
  get isSelectable(): boolean {
    return !!this.patient;
  }

  get filteredOptions(): DocumentSummary[] {
    if (this.$refs.dialogSelector.dialog && instanceOfIOptionFilterable<DocumentSummary>(this.$refs.dialogSelector.dialog)) {
      return this.$refs.dialogSelector.dialog.filteredOptions;
    } else {
      return null;
    }
  }

  get filteredText(): string {
    if (this.$refs.dialogSelector.dialog && instanceOfIOptionFilterable(this.$refs.dialogSelector.dialog)) {
      return this.$refs.dialogSelector.dialog.filteredText;
    } else {
      return "";
    }
  }
}
